<template src="./AppWeatherList.template.html"></template>

<script>
    const VueScrollTo = require('vue-scrollto');
    /*
    VueScrollTo.setDefaults({
        container: "#weather-center",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    });
    */

    import {windDescribe} from './constants.js'
    import { bus } from './bus.js'
    export default {
        name: 'listWeather',
        components: {
            VueScrollTo
        },
        data: () => ({
            listWeather: {},
            errors: []
        }),
        created() {

        },
        beforeMount() {
            this.init();
        },
        mounted() {

        },
        computed: {
        },
        methods: {
            init: function () {
                this.listWeather = this.$root.listWeather;
            },
            loadParameters() {

            },
            weatherItemClick(date) {
                bus.$emit('change-current-date', date);
                VueScrollTo.scrollTo('#weather-center', 500, { easing: 'linear' });
            },
            getWindDescribeById: function (id) {
                return id in windDescribe ? windDescribe[id] : '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/AppWeatherList.vue